import { ScoreType, User } from '../models';
import { HasId } from '../interfaces';

export class UserRawScore implements HasId {
    public id: number;
    public user: User;
    public userId: number;
    public scoreType: ScoreType;
    public scoreTypeID: number;
    public score: number;
}


// WEBPACK FOOTER //
// ./src/models/UserRawScore.tsx